import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { dateFormate, decryptedAdminID, MyModal } from "../../../../utility";
import { BsFillFunnelFill } from "react-icons/bs";
import ModalContainer from "../../../../components/modal_popup";
import { MenuItem, TextField } from "@mui/material";
import { AiOutlineClose } from "react-icons/ai";
import { GetAllAdminDetails } from "../../../../apiServices";
import { useDispatch } from "react-redux";
import { CandidateDashboardFilterActions } from "../../../../redux-store/store";
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
function TargetAnalyticsFilter() {
  const dispatch = useDispatch();
  const mothlyTargetFilter = useSelector(
    (state) => state.CandidateDashboardFilterDetails.AdminMonthlyTarget
  );
  const adminDetails = useSelector((state) => state.adminDetails);
  // console.log(adminDetails);
  const isTeamLeader = localStorage.getItem("teamLeader");

  let isSuperAdmin = adminDetails.roleID == 1;
  const initialObject = {
    adminId: Array.isArray(mothlyTargetFilter.adminId)
      ? mothlyTargetFilter.adminId
      : mothlyTargetFilter.adminId
      ? [mothlyTargetFilter.adminId]
      : [],
    startDate: mothlyTargetFilter.startDate,
    endDate: mothlyTargetFilter.endDate,
    page: mothlyTargetFilter.page,
    myTeam: mothlyTargetFilter.myTeam,
  };

  const [filter, setFilter] = useState(initialObject);
  const [filterShow, setFilterShow] = useState(false);

  const [adminOptions, setAdminOptions] = useState([]);
  const [dateRange, setDateRange] = useState({
    start: mothlyTargetFilter.startDate,
    end: mothlyTargetFilter.endDate,
  });
  const [month, setMonth] = useState();

  // useEffect(() => {
  //   const now = new Date();
  //   const currentMonthYear = `${months[now.getMonth()]} ${now.getFullYear()}`;
  //   setMonth(currentMonthYear);
  // }, []);
  useEffect(() => {
    const now = new Date();
    const currentMonth = now.getMonth(); // 0-11
    const currentYear = now.getFullYear();

    const startDate = new Date(mothlyTargetFilter.startDate);
    const startMonth = startDate.getMonth();
    const startYear = startDate.getFullYear();

    // Check if filter is for current month and year
    const isCurrentMonthYear =
      currentMonth === startMonth && currentYear === startYear;

    if (isCurrentMonthYear) {
      setMonth(`${months[currentMonth]} ${currentYear}`);
    } else {
      setMonth(`${months[startMonth]} ${startYear}`);
    }
  }, []);
  useEffect(() => {
    const teamLeaderId = localStorage.getItem("teamLeaderId");
    const teamLeader = localStorage.getItem("teamLeader");
    GetAllAdminDetails()
      .then((data) => {
        const withoutleaderID = teamLeaderId;
        const withoutleader = teamLeader;
        const activeAdmins = data.filter((item) => {
          const isActive = !item.Deactived;
          const isNotDeveloper = item.module !== "Developer";
          const isNotTeamLeader =
            teamLeader === "true" ? item.id !== teamLeaderId : true;
          return isActive && isNotDeveloper && isNotTeamLeader;
        });
        setAdminOptions(activeAdmins);
        console.log(activeAdmins, "activeAdmins");
      })
      .catch(() => {
        alert("Something Went wrong");
      });
  }, []);
  const handleAssignToChange = (e) => {
    const { value, name } = e.target;
    console.log(value, name);

    if (value === "myTeam") {
      const assignTo = parseInt(decryptedAdminID());

      setFilter((prev) => ({
        ...prev,
        myTeam: true,
        adminId: assignTo,
      }));
    } else if (value === "-1") {
      setFilter((prev) => ({
        ...prev,
        myTeam: false,
        adminId: -1,
      }));
    } else {
      setFilter((prev) => ({
        ...prev,
        myTeam: false,
        adminId: value,
      }));
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    // if (!dateRange.start || !dateRange.end) {
    //   setValidationErrors({
    //     start: !dateRange.start,
    //     end: !dateRange.end,
    //   });
    //   return;
    // }
    const [selectedMonth, selectedYear] = month.split(" ");
    const monthIndex = months.indexOf(selectedMonth);

    const startDate = new Date(selectedYear, monthIndex, 1);
    const endDate = new Date(selectedYear, monthIndex + 1, 0);

    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    };
    const payload = {
      adminId: filter.adminId,
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      dateFilterType: dateRange.dateFilterType || "",
      page: 1,
    };

    dispatch(
      CandidateDashboardFilterActions.setAdminMonthlyTargetFilter(payload)
    );
    setFilterShow(false);
  };

  const handleClear = (e) => {
    e.preventDefault();
    const clearedStartDate = dateFormate(
      new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    );
    const clearedEndDate = dateFormate(
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
    );

    const cleared = {
      adminId: [-1],
      startDate: clearedStartDate,
      endDate: clearedEndDate,
      dateFilterType: "",
      page: 1,
    };
    setFilter(cleared);
    const now = new Date();
    const currentMonthYear = `${months[now.getMonth()]} ${now.getFullYear()}`;
    setMonth(currentMonthYear);
    // setDateRange({
    //   start: clearedStartDate,
    //   end: clearedEndDate,
    //   dateFilterType: "",
    // });

    dispatch(
      CandidateDashboardFilterActions.setAdminMonthlyTargetFilter(cleared)
    );
  };

  return (
    <>
      <button
        className="btn btn-success "
        onClick={() => {
          setFilterShow(true);
        }}
      >
        <BsFillFunnelFill /> Filter
      </button>
      {filterShow && (
        <>
          <MyModal>
            <ModalContainer
              childComponent={
                <>
                  <div style={{ width: "300px" }}>
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <b>Filter</b>
                      </div>
                      <div>
                        <button
                          className="btn btn-danger"
                          onClick={() => {
                            setFilterShow(false);
                          }}
                        >
                          <AiOutlineClose />
                        </button>
                      </div>
                    </div>
                    <div>
                      <form>
                        <div className="mt-3">
                          <TextField
                            select
                            label="Filter Month"
                            name="month"
                            value={month}
                            onChange={(e) => setMonth(e.target.value)}
                            fullWidth
                          >
                            {(() => {
                              const startYear = 2025; // always start from 2025
                              const now = new Date();
                              const currentYear = now.getFullYear();

                              const items = [];

                              // loop from 2025 to current year (auto adds new years)
                              for (
                                let year = startYear;
                                year <= currentYear;
                                year++
                              ) {
                                months.forEach((m) => {
                                  items.push({
                                    label: `${m} ${year}`,
                                    value: `${m} ${year}`,
                                  });
                                });
                              }

                              return items.map((item) => (
                                <MenuItem key={item.value} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              ));
                            })()}
                          </TextField>
                        </div>
                        <div className="mt-3">
                          {adminOptions &&
                            (isSuperAdmin || isTeamLeader == "true") && (
                              <TextField
                                onChange={(e) => handleAssignToChange(e)}
                                name="AssignedTo"
                                id="AssignedTo"
                                className="form-control"
                                select
                                label="Assigned To"
                                value={
                                  filter.myTeam && !isSuperAdmin
                                    ? "myTeam"
                                    : filter.adminId
                                }
                                defaultValue={filter.adminId}
                              >
                                {isSuperAdmin && (
                                  <MenuItem value={-1}>ALL</MenuItem>
                                )}
                                {isTeamLeader == "true" && (
                                  <MenuItem value={"myTeam"}>My team</MenuItem>
                                )}

                                {isTeamLeader == "true" && (
                                  <MenuItem value={decryptedAdminID()}>
                                    Only for me
                                  </MenuItem>
                                )}
                                {adminOptions.map((el) => (
                                  <MenuItem key={el.id} value={el.id}>
                                    {el.userName}
                                  </MenuItem>
                                ))}
                              </TextField>
                            )}
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-2 mt-2">
                          <div>
                            <button
                              className="btn btn-danger"
                              onClick={handleClear}
                            >
                              Clear
                            </button>
                          </div>
                          <div>
                            <button
                              className="btn btn-success"
                              onClick={handleSearch}
                            >
                              Search
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              }
            />
          </MyModal>
        </>
      )}
    </>
  );
}

export default TargetAnalyticsFilter;
